import styled from 'styled-components';

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`;

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  cursor: pointer;
  flex-shrink: 0;
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;

  &:checked + span {
    background-color: #fa4616;
  }

  &:checked + span:before {
    transform: translateX(20px);
  }

  &:disabled + span {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus + span {
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.theme.name === 'dark'
          ? 'rgba(250, 70, 22, 0.2)'
          : 'rgba(250, 70, 22, 0.15)'};
  }
`;

export const ToggleSlider = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.2)'
      : 'rgba(0, 0, 0, 0.15)'};
  transition: all 0.3s ease;
  border-radius: 12px;

  &:before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 3px;
    top: 3px;
    background-color: ${(props) =>
      props.theme.name === 'dark' ? '#ffffff' : '#ffffff'};
    transition: all 0.3s ease;
    border-radius: 50%;
    box-shadow: ${(props) =>
      props.theme.name === 'dark'
        ? '0 2px 4px rgba(0, 0, 0, 0.3)'
        : '0 2px 4px rgba(0, 0, 0, 0.2)'};
  }
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#0F172A')};
  cursor: pointer;
  user-select: none;
`;
